import { render, staticRenderFns } from "./Gantt.vue?vue&type=template&id=5bd6c74e&scoped=true&"
import script from "./Gantt.vue?vue&type=script&lang=js&"
export * from "./Gantt.vue?vue&type=script&lang=js&"
import style0 from "./Gantt.vue?vue&type=style&index=0&id=5bd6c74e&lang=scss&scoped=true&"
import style1 from "./Gantt.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd6c74e",
  null
  
)

export default component.exports